import { useEffect, useRef } from 'react'
import { observeGameSession, type GameSessionSnapshot } from '../../../apiLayer/handlers/directDbHandler'

/** Exported for tests: only an operator's Back Office close ends a running game from outside; a plain `completed` never does. */
export const isGameSessionForceClosed = (session: GameSessionSnapshot | undefined): boolean =>
  Boolean(session?.forceClosedAt)

// An operator closed this session from the Back Office: leave the game the way the game itself ends, once.
export const useLeaveGameWhenForceClosed = (
  teamId: string | undefined,
  sessionId: string | undefined,
  leaveGame: () => void
): void => {
  const leaveGameRef = useRef(leaveGame)
  leaveGameRef.current = leaveGame

  useEffect(() => {
    if (!teamId || !sessionId) return undefined
    let hasLeft = false
    return observeGameSession(
      teamId,
      sessionId,
      (session) => {
        if (hasLeft || !isGameSessionForceClosed(session)) return
        hasLeft = true
        leaveGameRef.current()
      },
      (error) => console.error('observeGameSession failed', error)
    )
  }, [teamId, sessionId])
}
